import React, { useState, useContext, useEffect } from 'react'
import styled from 'styled-components'
import {
  FlexView,
  Button,
  TableHeader,
  TableList,
  FlexViewTable,
  Main,
  TitleCard,
  Spinner,
} from '../components/common'

import { useTranslation } from 'react-i18next'
import { AppContext } from '../stores/AppStore'
import { UserContext } from 'stores/UserStore'
import * as XLSX from 'xlsx'
import { SmartContext } from 'stores/SmartStore'
import { RiFileExcel2Line } from 'react-icons/ri'
import { DatePicker, Select } from 'components/form'
import { toast } from 'react-toastify'

const ButtonExcelLog = styled(Button)`
  padding: 8px 16px;
  border-radius: 4px;
  background: ${({ background }) => background};
  color: ${(color) => color};
  margin-left: 8px;
  cursor: pointer;
  font-weight: bold;
`

const Logs = () => {
  const DatePickerFrom = (props) => {
    return <DatePicker value={fromDate} onChange={setFromDate} {...props} />
  }

  const DatePickerTo = (props) => {
    return <DatePicker value={toDate} onChange={setTODate} {...props} />
  }

  const DEFAULT_URL = 'collaborative-design/home'

  const { t } = useTranslation()

  const { setPageSubtitle } = useContext(AppContext)
  const { registryLog, registryLogOld } = useContext(UserContext)
  const { applications, tableData, getLogData, searchLogData, isLoading } = useContext(
      SmartContext
  )
  const [fromDate, setFromDate] = useState()
  const [toDate, setTODate] = useState()
  const [application, setApplication] = useState()
  const [applicationType, setApplicationType] = useState()
  const [applicationsType, setApplicationsType] = useState([])

  const columns = [
    {
      Header: t('log.application'),
      accessor: 'application',
      id: 'application'
    },
    {
      Header: t('log.date'),
      accessor: (row) =>
          new Date(row.date).toLocaleDateString('pt-br', { timeZone: 'utc' }),
      id: 'date'
    },
    {
      Header: t('log.email'),
      accessor: 'email',
      id: 'email'
    },
    {
      Header: t('log.action'),
      accessor: 'action',
      id: 'action'
    },
    {
      Header: t('log.functionality'),
      accessor: 'functionality',
      id: 'functionality'
    },
    {
      Header: t('log.detail'),
      accessor: 'detail',
      id: 'detail'
    },
    {
      Header: t('log.url'),
      accessor: 'url',
      id: 'url'
    },
    {
      Header: t('log.source_ip'),
      accessor: 'source_ip',
      id: 'source_ip'
    },
    {
      Header: t('log.device'),
      accessor: 'device',
      id: 'device'
    },
    {
      Header: t('log.country'),
      accessor: 'country',
      id: 'country'
    },
    {
      Header: t('log.state'),
      accessor: 'state',
      id: 'state'
    },
    {
      Header: t('log.city'),
      accessor: 'city',
      id: 'city'
    },
    {
      Header: t('log.user'),
      accessor: 'user',
      id: 'user'
    },
    {
      Header: t('log.application_type'),
      accessor: 'application_type',
      id: 'application_type'
    }

  ]

  const onExcelClick = () => {
    const sheets = []
    sheets.push({
      data: tableData.map((row) => {
        const obj = {}
        obj[t('log.application')] = row.application
        obj[t('log.date')] = new Date(row.date).toLocaleDateString('pt-br', { timeZone: 'utc' })
        obj[t('log.email')] = row.email
        obj[t('log.action')] = row.action
        obj[t('log.functionality')] = row.functionality
        obj[t('log.detail')] = row.detail
        obj[t('log.url')] = row.url
        obj[t('log.source_ip')] = row.source_ip
        obj[t('log.device')] = row.device
        obj[t('log.country')] = row.country
        obj[t('log.state')] = row.state
        obj[t('log.city')] = row.city
        obj[t('log.user')] = row.user
        obj[t('log.application_type')] = row.application_type
        return obj
      }),
      name: t('report.title'),
    })
    const workbook = { SheetNames: [], Sheets: {} }
    sheets.forEach(function(row) {
      const sheetName = row.name
      const worksheet = XLSX.utils.json_to_sheet(row.data)
      workbook.SheetNames.push(sheetName)
      workbook.Sheets[sheetName] = worksheet
    })
    const options = { bookType: 'xlsx', type: 'array' }
    XLSX.writeFile(workbook, 'smart-report' + Date.now() + '.xlsx', options)

    registryLog('logs', "click", "export_excel")
  }

  const onSearchClick = () => {
    searchLogData({fromDate, toDate, application, applicationType})
    registryLog('logs', "click", "search")
  }

  useEffect(() => {
    setPageSubtitle(t('home.pageTitle'))
    registryLogOld('client_in', DEFAULT_URL)
    registryLog('logs', "navigation", "client_in")
    getLogData()
    setApplicationsType([{label: 'Web', value: 'WEB'}, {label: 'Mobile', value: 'MOBILE'}])
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  const handleSelectInput = value => {
    setApplication(value)
  }

  const handleSelectAppTypeInput = value => {
    setApplicationType(value)
  }

  return (
      <FlexViewTable>
        {!isLoading ? (
            <Main>
              <TableHeader>
                <DatePickerFrom label={t('report.from')} name="from" /> &nbsp;&nbsp;
                <DatePickerTo label={t('report.to')} width="100%" name="to" />{' '}
                &nbsp;&nbsp;
                <Select placeholder={t('selectAll')} margin="0px" label={t('log.applications')}
                        options={applications} value={application} width="100%"
                        onChange={handleSelectInput} />
                &nbsp;&nbsp;

                <Select placeholder={t('selectAll')} margin="0px" label={t('log.application_type')}
                        options={applicationsType} value={applicationType} width="100%"
                        onChange={handleSelectAppTypeInput} />
                &nbsp;&nbsp;
                <TitleCard>
                  <Button
                      style={{ marginTop: '20px' }}
                      backgroundColor="primary"
                      color="white"
                      fontSize="small"
                      elevation="medium"
                      onClick={onSearchClick}
                  >
                    {' '}
                    &nbsp;
                    {t('report.search')}
                  </Button>{' '}
                  &nbsp; &nbsp;
                  <ButtonExcelLog
                      style={{ marginTop: '20px', backgroundColor: '#e5e5e5' }}
                      color="primary"
                      fontSize="small"
                      onClick={onExcelClick}
                  >
                    <RiFileExcel2Line
                        style={{ width: '35px', height: '35px', color: '#59CBE4' }}
                        onClick={() => onExcelClick()}
                    />
                  </ButtonExcelLog>
                </TitleCard>
              </TableHeader>
              <TableList
                  width="100%"
                  columns={columns}
                  data={tableData}
                  sortable
                  elevation="none"
                  borderRadius="card"
                  paginated
                  margin="8px 16px"
                  style={{ whiteSpace: 'nowrap' }}
              />
            </Main>
        ) : (
            <FlexView
                justifyContent="center"
                alignItems="center"
                width="100%"
                height="100%"
            >
              <Spinner />
            </FlexView>
        )}
      </FlexViewTable>
  )
}
export default Logs
